import React from "react";

const NotFoundView:React.FC = ()=>{
    return <>Not Found</>
}
export default NotFoundView;